import { useState, useEffect, useCallback, useMemo } from "react";
import { getData } from "../../api/ApiRest";
import LoadingComponent from "./../../widgets/LoadingComponent";
import Form from "react-bootstrap/Form";
import { exportToExcel } from "react-json-to-excel";
import TableInformation from "../../components/common/TableComponent";
import { Grid } from "@mui/material";
import { getDataPlanReport } from "../../components/services/companyAPI";

function EmpresaPlan() {
  const [loading, setLoading] = useState(false);
  const [planesActivos, setPlanesActivos] = useState(true);
  const [reportePlanes, setReportePlanes] = useState({});
  const [isAllCategory, setIsAllCategory] = useState(false);

  const totalPlanes = useMemo(() => {
    let result;
    if (planesActivos) {
      result =
        reportePlanes?.planesProxVencer?.length +
        reportePlanes?.planesVigentes?.length;
    } else {
      result = reportePlanes?.planesVencidos?.length;
    }

    if (isAllCategory) {
      result =
        reportePlanes?.planesProxVencer?.length +
        reportePlanes?.planesVigentes?.length +
        reportePlanes?.planesVencidos?.length;
    }

    return result;
  }, [reportePlanes, isAllCategory, planesActivos]);

  const cargarReportePlanes = useCallback(async () => {
    const result = await getDataPlanReport(planesActivos);
    setReportePlanes(result);
  }, [planesActivos]);

  useEffect(() => {
    setLoading(true);
    cargarReportePlanes();
    setLoading(false);
  }, [cargarReportePlanes]);

  const buscarPlanes = async (event) => {
    setLoading(true);
    const { value } = event.target;

    const booleanPlan = {
      active: true,
      inactive: false,
    };

    if (value === "all") {
      setIsAllCategory(true);
      const result = await getDataPlanReport(true, true);
      setReportePlanes(result);
      // setPlanesActivos(booleanPlan[value]);
      setLoading(false);
      return;
    } else {
      setIsAllCategory(false);
    }

    setReportePlanes([]);
    const result = await getDataPlanReport(booleanPlan[value]);
    setReportePlanes(result);
    setPlanesActivos(booleanPlan[value]);
    setLoading(false);
  };

  const descagarFacturaDatos = (item) => {
    setLoading(true);

    getData(
      "api/Configuracion/Reporte/GetReporteEmisionPlanExcel",
      {
        Id: item.company_PlanId,
      },
      false
    ).then(
      (response) => {
        exportToExcel(response.dias, item.empresa);
        setLoading(false);
      },
      (error) => {
        alert("Algo salio mal en la peticion");
        setLoading(false);
      }
    );
  };

  return (
    <div className="BodyComponent">
      <LoadingComponent Loading={loading} />
      <h3 className="text-center">
        REPORTE DE EMISION DE PLANES: {totalPlanes || 0}
      </h3>

      <div className="row">
        <div className="col-md-6">
          <Form.Select
            aria-label="Estado de planes a mostrar"
            defaultValue={"active"}
            onChange={(event) => buscarPlanes(event)}
          >
            <option value="all">Todos</option>
            <option value={"active"}>Activos</option>
            <option value={"inactive"}>Inactivos</option>
          </Form.Select>
        </div>
      </div>

      <Grid container direction={"column"} gap={"0rem"}>
        {!planesActivos || isAllCategory ? (
          <>
            <Grid item>
              <TableInformation
                registerEmission={reportePlanes?.planesVencidos}
                title={"PLANES VENCIDOS"}
                typeCategory={"vencimiento"}
                colorSetting={"danger"}
              />
            </Grid>
          </>
        ) : (
          <></>
        )}
        {planesActivos || isAllCategory ? (
          <>
            <Grid item>
              <TableInformation
                registerEmission={reportePlanes?.planesProxVencer}
                title={"PLANES CERCANOS A VENCER"}
                typeCategory={"cercanos"}
                colorSetting={"warning"}
                typeReport={"Vencimiento"}
              />
            </Grid>

            <Grid item>
              <TableInformation
                registerEmission={reportePlanes?.planesVigentes}
                title={"PLANES VIGENTES"}
                typeCategory={"vigente"}
                bgColorTitle={"normal"}
              />
            </Grid>
          </>
        ) : (
          <></>
        )}
      </Grid>
    </div>
  );
}

export default EmpresaPlan;
